import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import IsNumberUniqueResponse from 'features/care-connect-settings/domain/models/is-number-unique-response';

const vcareNumberBaseUrl = '/api/v1/VcareNumber';

enum NumberQueryPaths {
  IsNumberUnique = 'IsNumberUnique',
}

const isNumberUnique = async (axiosInstance: AxiosInstance, number: string): Promise<boolean> => {
  const response = await axiosInstance.get<IsNumberUniqueResponse>(`${vcareNumberBaseUrl}/${NumberQueryPaths.IsNumberUnique}/${number}`);
  return response.data.isUnique;
};

export const useIsNumberUnique = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationFn: (number: string) => isNumberUnique(authenticatedInstance, number),
  });
};
